export default __webpack_public_path__ + "static/media/history-icon.62a07e99.svg";